import { IAction } from 'core/interface/action';

export const SAVE_VALUES = 'save-extra-activites';

const defaultState = {
  extraActivities: null
};

export const SaveExtraActivites = (value: any | number[]) => ({
  type: SAVE_VALUES,
  payload: value
});

const extraActivitesReducer = (
  state = defaultState,
  action: IAction<any | number[]>
) => {
  switch (action.type) {
    case SAVE_VALUES:
      return {
        ...state,
        extraActivities: action.payload
      };
    default:
      return state;
  }
};

export default extraActivitesReducer;
